import { DetalhesFiltrosModel } from "@/models/detalhesFiltrosModel";
import * as Icon from "@ant-design/icons";
import { Button, Col, DatePicker, DatePickerProps, Divider, Drawer, Flex, Form, Image, Modal, Radio, RadioChangeEvent, Row, Select, Tooltip, Typography, UploadFile } from "antd";
import { ColumnsType } from "antd/lib/table";
import dayjs from "dayjs";
import * as PhosphorIcon from "phosphor-react";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ButtonComponent } from "../../../../components/button/cadastrar";
import { Filtro } from "../../../../components/filtroComponent/filtro";
import FiltroComponent from "../../../../components/filtroComponent/filtroComponent";
import MensagemModal from "../../../../components/modal/mensagem";
import AcoesComponent from "../../../../components/table/acoesComponent";
import TableComponent from "../../../../components/table/tableComponent";
import UploadArquivosComponent from "../../../../components/uploadArquivosComponent";
import { AnexoItemModel } from "../../../../models/arquivoAnexo/anexoItemModel";
import { ArquivoAnexoModel } from "../../../../models/arquivoAnexo/arquivoAnexoModel";
import { TipoArquivoAnexoModel } from "../../../../models/arquivoAnexo/tipoArquivoAnexoModel";
import { BuscarContaFinanceiraModel } from "../../../../models/contaFinanceira/chamadas/buscarContaFinanceiraModel";
import { ContaFinanceiraModel } from "../../../../models/contaFinanceira/contaFinanceiraModel";
import { RateioModel } from "../../../../models/contaFinanceira/rateioModel";
import { EmpresaModel } from "../../../../models/empresa/empresaModel";
import { ItemMenuAcoes } from "../../../../models/sistema/itemMenuAcoes";
import { SelectedRowKeysModel } from "../../../../models/sistema/selectedRowKeysModel";
import { setDataSourceAnexo, setEditingKeyAnexo, setModalArquivo } from "../../../../redux/slices/arquivoAnexo/arquivoAnexoSlice";
import { setIdEmpresaPermissao, setTitle } from "../../../../redux/slices/configuracoes/configuracoesSlice";
import {
  setBuscaContaFinanceira,
  setEntityContaFinanceira,
  setModalDeletarContaFinanceira,
  setModalHistoricoContaFinanceira,
  setModalRateioContaFinanceira,
  setOrigemCadastro,
  setPageContaFinanceira,
  setSelectedRowKeysContaFinanceira,
  setTipoAcao,
  setTipoCadastro,
} from "../../../../redux/slices/contaFinanceira/contaFinanceiraSlice";
import { listarArquivoAnexo, listarTipoArquivoAnexo } from "../../../../services/arquivoAnexoService";
import { buscarContaBanco } from "../../../../services/contaBancoService";
import { buscarContaFinanceira, cancelarContaFinanceira, deletarContaFinanceira, listarPlanosContaFinanceiro, listarRateioContaFinanceira } from "../../../../services/contaFinanceiraService";
import { buscarEmpresa } from "../../../../services/empresaService";
import { buscarGrupoPlanoContaFinanceiro } from "../../../../services/grupoPlanoContaFinanceiroService";
import { buscarPessoa } from "../../../../services/pessoaService";
import { currencyBRL } from "../../../../util/dinheiroBRAuxiliar";
import { verificarPermissaoEmpresa } from "../../../../util/functions/verificarPermissaoEmpresa";
import { useAppDispatch, useAppSelector } from "../../../../util/hooks";
import VisualizarArquivos from "../../modals/arquivos";
import HistoricoContaFinanceira from "../../modals/historico";
import Rateio from "../../modals/rateio";
import ResumoContaFinanceira from "../../modals/resumo";
import "./style/index.scss";

dayjs.locale("pt-br");

const GeralPage = () => {
  //estados globais
  const contaFinanceiraState = useAppSelector((state) => state.contaFinanceira);
  const empresaState = useAppSelector((state) => state.empresa);
  const arquivoAnexoState = useAppSelector((state) => state.arquivoAnexo);
  const pessoaState = useAppSelector((state) => state.pessoa);
  const grupoPlanoContaFinanceiroState = useAppSelector((state) => state.grupoPlanoContaFinanceiro);
  const resultadoSorteioState = useAppSelector((state) => state.resultadoSorteio);
  const contaBancoState = useAppSelector((state) => state.contaBanco);
  const persistedState = useAppSelector((state) => state.persisted);
  const planoContaFinanceiroState = useAppSelector((state) => state.planoContaFinanceiro);

  //hooks
  const dispatch = useAppDispatch();
  const location = useLocation();

  //estados locais
  const [form] = Form.useForm();
  const [openFiltros, setOpenFiltros] = useState<boolean>(false);
  const [valor, setValor] = useState<number>(0);
  const [idGrupoPlano, setIdGrupo] = useState<number>(1);
  const [openVisualizarArquivos, setOpenVisualizarArquivos] = useState<boolean>(false);
  const [openVisualizarResumo, setOpenVisualizarResumo] = useState<boolean>(false);
  const [idEmpresaAtual, setIdEmpresaAtual] = useState<number | null>(null);
  const [abrirDetalhes, setAbrirDetalhes] = useState<boolean>(false);

  const [valueRadioDespesaReceita, setValueRadioDespesaReceita] = useState("D");
  const radioOptions = [
    { label: "Pagar", value: "D" },
    { label: "Receber", value: "R" },
  ];

  const [valueRadioPendente, setValueRadioPendente] = useState(false);
  const radioOptionsPendente = [
    { label: "Pendentes", value: false },
    { label: "Todas", value: true },
  ];

  const [valueRadioParcelado, setValueRadioParcelado] = useState(false);
  const radioOptionsParcelado = [
    { label: "Todas", value: false },
    { label: "Parceladas", value: true },
  ];

  const pagar = location.pathname === "/contaPagar";
  const guia = location.pathname === "/contaFinanceiraGuia";
  const pendencia = location.pathname === "/contaFinanceiraContabilidade";

  const selectionType = !(pendencia || guia) ? (abrirDetalhes ? "radio-allowed" : "checkbox") : undefined;

  useEffect(() => {
    setOpenFiltros(false);

    let busca: BuscarContaFinanceiraModel = {
      ...contaFinanceiraState.busca,
      receitaDespesa: pagar || guia || pendencia ? "D" : "R",
      geraContabil: guia || pendencia ? true : null,
      temAnexoComprovante: pendencia ? false : null,
      origem: guia ? "GUIA" : null,
      parcelado: guia || pendencia || !pagar ? null : valueRadioParcelado ? true : null,
    };

    var buscaPessoa = { ...pessoaState.busca, exibeContaPagar: pagar || guia ? true : false, exibeContaReceber: pagar || guia ? false : true };

    //setando valores iniciais de conta financeira
    form.setFieldsValue({
      filtroTipo: "VENCI",
      idEmpresa: busca.idEmpresa,
      idContaBanco: null,
      dataInicio: dayjs(busca.dataInicio),
      dataFim: dayjs(busca.dataFim),
      grupoPlano: idGrupoPlano,
    });

    //busca contas a pagar se vem de resultado sorteio
    if (resultadoSorteioState.comesFromResultado) {
      busca.tipoFiltroData = "SORTE";
      busca.dataInicio = resultadoSorteioState.dataSorteio;
      busca.idEmpresa = resultadoSorteioState.idEmpresa;
      busca.filtros = [
        {
          campo: "PlanoContaFinanceiro",
          operador: "EQ",
          valor: resultadoSorteioState.planoContaFinanceiro?.id,
        },
      ] as DetalhesFiltrosModel[];

      setIdEmpresaAtual(resultadoSorteioState.idEmpresa);
      setOpenFiltros(true);

      form.setFieldsValue({ filtroTipo: "SORTE", dataInicio: dayjs(busca.dataInicio), idEmpresa: resultadoSorteioState.idEmpresa });
    }

    if (persistedState.user.empresa !== null) {
      dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: persistedState.user.empresa.idEmpresa }));
      busca.idEmpresa = persistedState.user.empresa.idEmpresa;
      setIdEmpresaAtual(persistedState.user.empresa.idEmpresa);
      dispatch(setBuscaContaFinanceira(busca));
      dispatch(buscarContaFinanceira(busca));
    } else {
      dispatch(buscarContaBanco(contaBancoState.busca));
    }

    //dispatchs
    dispatch(setTitle(pagar ? "CONTAS A PAGAR" : guia ? "CONTROLE DE GUIAS E RECOLHIMENTO" : pendencia ? "PENDÊNCIAS DE CONTAS FINANCEIRAS" : "CONTAS A RECEBER"));
    dispatch(setBuscaContaFinanceira(busca));
    dispatch(buscarContaFinanceira(busca));
    if (planoContaFinanceiroState.list.length === 0) dispatch(listarPlanosContaFinanceiro());
    if (arquivoAnexoState.listTipo.length === 0) dispatch(listarTipoArquivoAnexo("cfin"));
    if (pessoaState.list.length === 0) dispatch(buscarPessoa(buscaPessoa));
    if (empresaState.list.length === 0) dispatch(buscarEmpresa(empresaState.busca));
    if (grupoPlanoContaFinanceiroState.list.length === 0) dispatch(buscarGrupoPlanoContaFinanceiro(grupoPlanoContaFinanceiroState.busca));
  }, [location, resultadoSorteioState.comesFromResultado]);

  const goCadastrar = () => {
    dispatch(setEntityContaFinanceira({}));
    dispatch(setOrigemCadastro("contaFinanceira"));
    dispatch(setTipoAcao("cadastrar"));
    dispatch(setTipoCadastro(pagar || guia || pendencia ? "despesa" : "receita"));
    dispatch(setPageContaFinanceira("cadastrar"));
  };

  const goEditar = (value: ContaFinanceiraModel) => {
    dispatch(setEntityContaFinanceira(value));
    dispatch(setOrigemCadastro("contaFinanceira"));
    dispatch(setTipoCadastro(pagar || guia || pendencia ? "despesa" : "receita"));
    dispatch(setTipoAcao("editar"));
    dispatch(setPageContaFinanceira("cadastrar"));
  };

  const goDuplicar = (value: ContaFinanceiraModel) => {
    dispatch(setEntityContaFinanceira(value));
    dispatch(setOrigemCadastro("contaFinanceira"));
    dispatch(setTipoCadastro(pagar || guia || pendencia ? "despesa" : "receita"));
    dispatch(setTipoAcao("duplicar"));
    dispatch(setPageContaFinanceira("cadastrar"));
  };

  const goDeletar = (value: ContaFinanceiraModel) => {
    dispatch(setEntityContaFinanceira(value));
    dispatch(setModalDeletarContaFinanceira(true));
  };

  const closeModalDeletar = () => {
    dispatch(setModalDeletarContaFinanceira(false));
  };

  const goPagar = () => {
    dispatch(setOrigemCadastro("contaFinanceira"));
    dispatch(setTipoCadastro(pagar || guia || pendencia ? "despesa" : "receita"));
    dispatch(setPageContaFinanceira("pagamentos"));
  };

  const goVisualizarPagamento = (value: any) => {
    dispatch(setEntityContaFinanceira(value));
    dispatch(setPageContaFinanceira("visualizarPagamentos"));
  };

  const goRateio = () => {
    dispatch(setModalRateioContaFinanceira(true));
  };

  const closeModalRateio = () => {
    dispatch(setModalRateioContaFinanceira(false));
  };

  const goHistorico = (value: ContaFinanceiraModel) => {
    dispatch(setEntityContaFinanceira(value));
    dispatch(setModalHistoricoContaFinanceira(true));
  };

  const closeModalHistorico = () => {
    dispatch(setModalHistoricoContaFinanceira(false));
  };

  const goAnexarArquivo = async () => {
    const retorno = await dispatch(listarArquivoAnexo(contaFinanceiraState.selectedRowKeys.keys[0]));
    let imagens = retorno.payload.filter((a: ArquivoAnexoModel) => arquivoAnexoState.listTipo.some((tipo: TipoArquivoAnexoModel) => tipo.id === a.idTipoArquivoAnexo));
    if (imagens.length !== 0) {
      var initialData: AnexoItemModel[] = [];
      for (let i = 0; i < imagens.length; i++) {
        initialData.push({
          key: i.toString(),
          arquivo: {
            uid: "-1",
            name: imagens[i].nome,
            status: "done",
            type: imagens[i].extensaoArquivo,
            url: imagens[i].caminhoArquivo,
          },
          caminhoArquivo: imagens[i].caminhoArquivo,
          idTipoArquivoAnexo: imagens[i].idTipoArquivoAnexo,
          observacao: imagens[i].observacao,
        });
      }
      dispatch(setDataSourceAnexo(initialData));
      dispatch(setEditingKeyAnexo(""));
    } else {
      var initialData: AnexoItemModel[] = [];
      for (let i = 0; i < 1; i++) {
        initialData.push({
          key: "1",
          arquivo: {} as UploadFile,
          caminhoArquivo: null,
          idTipoArquivoAnexo: null,
          observacao: null,
        });
      }
      dispatch(setEditingKeyAnexo(initialData[0].key));
      dispatch(setDataSourceAnexo(initialData));
    }
    dispatch(setModalArquivo(true));
  };

  const goAnexarArquivoMenu = async (value: any) => {
    dispatch(setEntityContaFinanceira(value));
    const retorno = await dispatch(listarArquivoAnexo(value.id));
    let imagens = retorno.payload.filter((a: ArquivoAnexoModel) => arquivoAnexoState.listTipo.some((tipo: TipoArquivoAnexoModel) => tipo.id === a.idTipoArquivoAnexo));
    if (imagens.length !== 0) {
      var initialData: AnexoItemModel[] = [];
      for (let i = 0; i < imagens.length; i++) {
        initialData.push({
          key: i.toString(),
          arquivo: {
            uid: "-1",
            name: imagens[i].nome,
            status: "done",
            type: imagens[i].extensaoArquivo,
            url: imagens[i].caminhoArquivo,
          },
          caminhoArquivo: imagens[i].caminhoArquivo,
          idTipoArquivoAnexo: imagens[i].idTipoArquivoAnexo,
          observacao: imagens[i].observacao,
        });
      }
      dispatch(setDataSourceAnexo(initialData));
      dispatch(setEditingKeyAnexo(""));
    } else {
      var initialData: AnexoItemModel[] = [];
      for (let i = 0; i < 1; i++) {
        initialData.push({
          key: "1",
          arquivo: {} as UploadFile,
          caminhoArquivo: null,
          idTipoArquivoAnexo: null,
          observacao: null,
        });
      }
      dispatch(setEditingKeyAnexo(initialData[0].key));
      dispatch(setDataSourceAnexo(initialData));
    }
    dispatch(setModalArquivo(true));
  };

  const closeModalArquivo = () => {
    dispatch(setModalArquivo(false));
  };

  const goVisualizarArquivos = (value: any) => {
    dispatch(setEntityContaFinanceira(value));
    setOpenVisualizarArquivos(true);
  };

  const closeVisualizarArquivos = () => {
    setOpenVisualizarArquivos(false);
  };

  const goVisualizarResumo = (value: ContaFinanceiraModel) => {
    dispatch(setEntityContaFinanceira(value));
    setOpenVisualizarResumo(true);
  };

  const closeVisualizarResumo = () => {
    setOpenVisualizarResumo(false);
  };

  const cancelar = (value: ContaFinanceiraModel) => {
    dispatch(cancelarContaFinanceira({ value: value.id, busca: contaFinanceiraState.busca }));
  };

  const clicouDetalhes = () => {
    dispatch(setSelectedRowKeysContaFinanceira({ rows: [], keys: [] } as SelectedRowKeysModel));
    setAbrirDetalhes(!abrirDetalhes);
  };

  const onChangeEmpresa = (value: number) => {
    dispatch(setIdEmpresaPermissao(value));

    setIdEmpresaAtual(value);

    let busca: BuscarContaFinanceiraModel = { ...contaFinanceiraState.busca, idEmpresa: value };

    dispatch(setBuscaContaFinanceira(busca));
    dispatch(buscarContaFinanceira(busca));
    dispatch(buscarContaBanco({ pesquisar: null, id: null, idEmpresa: value }));
  };

  const onChangeFiltroTipo = (value: string) => {
    let busca: BuscarContaFinanceiraModel = { ...contaFinanceiraState.busca, tipoFiltroData: value };

    dispatch(setBuscaContaFinanceira(busca));
    dispatch(buscarContaFinanceira(busca));
  };

  const onChangeDateInicio = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscarContaFinanceiraModel = { ...contaFinanceiraState.busca, dataInicio: dayjs(value).toDate() };

    dispatch(setBuscaContaFinanceira(busca));
    dispatch(buscarContaFinanceira(busca));
  };

  const onChangeDateFim = (value: DatePickerProps["value"], dateString: string | string[]) => {
    let busca: BuscarContaFinanceiraModel = { ...contaFinanceiraState.busca, dataFim: dayjs(value).toDate() };

    dispatch(setBuscaContaFinanceira(busca));
    dispatch(buscarContaFinanceira(busca));
  };

  const onChangeStatusGuia = (value: string) => {
    let busca: BuscarContaFinanceiraModel = { ...contaFinanceiraState.busca, statusGuia: value };

    dispatch(setBuscaContaFinanceira(busca));
    dispatch(buscarContaFinanceira(busca));
  };

  const onChangeRadioDespesaReceita = ({ target: { value } }: RadioChangeEvent) => {
    setValueRadioDespesaReceita(value);

    let busca: BuscarContaFinanceiraModel = { ...contaFinanceiraState.busca, receitaDespesa: value };

    dispatch(setBuscaContaFinanceira(busca));
    dispatch(buscarContaFinanceira(busca));
  };

  const onChangeRadioPendente = ({ target: { value } }: RadioChangeEvent) => {
    setValueRadioPendente(value);

    let busca: BuscarContaFinanceiraModel = { ...contaFinanceiraState.busca, temAnexoComprovante: !value ? false : null };

    dispatch(setBuscaContaFinanceira(busca));
    dispatch(buscarContaFinanceira(busca));
  };

  const onChangeRadioParcelado = ({ target: { value } }: RadioChangeEvent) => {
    setValueRadioParcelado(value);

    let busca: BuscarContaFinanceiraModel = { ...contaFinanceiraState.busca, parcelado: !value ? null : true };

    dispatch(setBuscaContaFinanceira(busca));
    dispatch(buscarContaFinanceira(busca));
  };

  const atualizar = () => {
    dispatch(buscarContaFinanceira(contaFinanceiraState.busca));
  };

  //componente de filtro
  const onChangeMostrarFiltros = async () => {
    try {
      await form.validateFields();
      setOpenFiltros(!openFiltros);
    } catch (e) {}
  };

  const selecionarLinha = (value: SelectedRowKeysModel) => {
    dispatch(setSelectedRowKeysContaFinanceira(value));
    if (selectionType === "radio-allowed") dispatch(listarRateioContaFinanceira(value.keys[0]));
  };

  const items: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <PhosphorIcon.Pencil size={16} color="#212937" weight="light" />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <PhosphorIcon.XCircle size={16} color="#212937" weight="light" />,
      function: (item: any) => goDeletar(item),
    },
    {
      label: "Cancelar",
      key: "3",
      icon: <PhosphorIcon.Prohibit size={16} color="#212937" weight="light" />,
      function: (item: any) => cancelar(item),
    },
    {
      label: "Duplicar",
      key: "4",
      icon: <PhosphorIcon.Copy size={16} color="#212937" weight="light" />,
      function: (item: any) => goDuplicar(item),
    },
    {
      label: "Ver Pagamentos",
      key: "5",
      icon: <PhosphorIcon.Money size={16} color="#212937" weight="light" />,
      function: (item: any) => goVisualizarPagamento(item),
    },
    {
      label: "Anexos",
      key: "6",
      icon: <Icon.PaperClipOutlined />,
      function: (item: any) => goAnexarArquivoMenu(item),
    },
    {
      label: "Histórico",
      key: "7",
      icon: <PhosphorIcon.ChartLine size={16} color="#212937" weight="light" />,
      function: (item: any) => goHistorico(item),
    },
  ];

  const itemsPendencia: ItemMenuAcoes[] = [
    {
      label: " Mais informações",
      key: "1",
      icon: <Icon.InfoCircleOutlined size={16} color="#212937" />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Anexos",
      key: "2",
      icon: <Icon.PaperClipOutlined />,
      function: (item: any) => goAnexarArquivoMenu(item),
    },
    {
      label: "Histórico",
      key: "3",
      icon: <PhosphorIcon.ChartLine size={16} color="#212937" weight="light" />,
      function: (item: any) => goHistorico(item),
    },
  ];

  const itemsGuia: ItemMenuAcoes[] = [
    {
      label: "Editar",
      key: "1",
      icon: <PhosphorIcon.Pencil size={16} color="#212937" weight="light" />,
      function: (item: any) => goEditar(item),
    },
    {
      label: "Remover",
      key: "2",
      icon: <PhosphorIcon.XCircle size={16} color="#212937" weight="light" />,
      function: (item: any) => goDeletar(item),
    },
    {
      label: "Anexos",
      key: "3",
      icon: <Icon.PaperClipOutlined />,
      function: (item: any) => goAnexarArquivoMenu(item),
    },
    {
      label: "Histórico",
      key: "4",
      icon: <PhosphorIcon.ChartLine size={16} color="#212937" weight="light" />,
      function: (item: any) => goHistorico(item),
    },
  ];

  const columns: ColumnsType<ContaFinanceiraModel> = [
    {
      title: "STATUS",
      dataIndex: "situacaoConta",
      width: 70,
      align: "center",
      filters: [
        {
          text: "Prevista",
          value: "Prevista" as any,
        },
        {
          text: "Programada",
          value: "Programada" as any,
        },
        {
          text: "Quitada",
          value: "Paga" as any,
        },
        {
          text: "Cancelada",
          value: "Cancelada" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.situacaoConta.toString().includes(value),
      render: (_, record) => {
        return (
          <Flex justify="center">
            {record.situacaoConta === "Prevista" ? (
              <div className="circlePV">PV</div>
            ) : record.situacaoConta === "Programada" ? (
              <div className="circlePR">PR</div>
            ) : record.situacaoConta === "Cancelada" ? (
              <div className="circleCC">CC</div>
            ) : (
              <div className="circleQT">QT</div>
            )}
          </Flex>
        );
      },
    },
    {
      title: "AUDIT.",
      dataIndex: ["denominacaoStatusAuditoria", "observacaoAuditoria"],
      width: 80,
      align: "center",
      filters: [
        {
          text: "Aprovado",
          value: "Aprovado" as any,
        },
        {
          text: "Rejeitado",
          value: "Rejeitado" as any,
        },
        {
          text: "Pendente",
          value: "Pendente" as any,
        },
      ],
      onFilter: (value: any, record: any) => record.denominacaoStatusAuditoria.toString().includes(value),
      render: (_, record) => {
        return (
          <>
            {record.denominacaoStatusAuditoria === "Aprovado" ? (
              <Tooltip title={record.denominacaoStatusAuditoria}>
                <Icon.CheckSquareOutlined className="buttonAprovarC" />
              </Tooltip>
            ) : record.denominacaoStatusAuditoria === "Rejeitado" ? (
              <Tooltip title={record.denominacaoStatusAuditoria}>
                <Icon.StopOutlined className="buttonRejeitarC" />
              </Tooltip>
            ) : (
              <Tooltip title={record.denominacaoStatusAuditoria}>
                <PhosphorIcon.HourglassMedium className="buttonPendenteC" size={15} color="#212937" weight="light" />
              </Tooltip>
            )}
          </>
        );
      },
    },
    {
      title: "DOC.",
      dataIndex: "numeroDocumento",
      width: 100,
    },
    {
      title: pagar || guia ? "FORNECEDOR" : "CLIENTE",
      dataIndex: "apelidoPessoa",
      sorter: (a, b) => a.apelidoPessoa.localeCompare(b.apelidoPessoa),
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => (
        <Typography.Text style={{ width: 200 }} ellipsis={{ tooltip: record.apelidoPessoa }}>
          {record.apelidoPessoa}
        </Typography.Text>
      ),
    },
    {
      title: "PLANO DE CTA",
      dataIndex: "id",
      width: 130,
      align: "center",
      className: "buttonTooltip",
      render: (_, record) => {
        const planos = contaFinanceiraState.listPlanos.find((a: any) => a.idContaFinanceira === record.id);
        return (
          <>
            {planos && (
              <Tooltip
                title={planos.planoContaFinanceiro.map((a: any, index: number) => {
                  return (
                    <div key={index}>
                      <span>{a}</span>
                    </div>
                  );
                })}
              >
                <Button size="small">
                  <Icon.ContainerOutlined />
                </Button>
              </Tooltip>
            )}
          </>
        );
      },
    },
    {
      title: "VENCIMENTO",
      dataIndex: "dataVencimento",
      width: 80,
      render: (_, record) => {
        return <>{dayjs(record.dataVencimento).format("DD/MM/YYYY")}</>;
      },
    },
    {
      title: "VALOR",
      dataIndex: "valorBruto",
      align: "right",
      width: 130,
      sorter: (a: any, b: any) => a.valorBruto - b.valorBruto,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => currencyBRL(record.valorBruto),
    },
    {
      title: "VALOR PAGO",
      dataIndex: "valorPago",
      align: "right",
      width: 130,
      sorter: (a: any, b: any) => a.valorPago - b.valorPago,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => currencyBRL(record.valorPago),
    },
    {
      title: "SALDO A PAGAR",
      dataIndex: "saldoPagar",
      align: "right",
      width: 130,
      sorter: (a: any, b: any) => a.saldoPagar - b.saldoPagar,
      sortDirections: ["ascend", "descend", "ascend"],
      render: (_, record) => currencyBRL(record.saldoPagar),
    },
    {
      title: "HISTÓRICO",
      dataIndex: "historico",
      align: "center",
      fixed: "right",
      width: 75,
      className: "buttonTooltip",
      render: (_, record) =>
        record.historico !== null && (
          <Tooltip placement="top" title={record.historico}>
            <Button size="small">
              <Icon.FileTextOutlined />
            </Button>
          </Tooltip>
        ),
    },
    {
      title: "ANEXOS",
      dataIndex: "temAnexo",
      align: "center",
      width: 60,
      fixed: "right",
      className: "buttonTooltip",
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => (
        <>
          {record.temAnexo && (
            <Button size="small" onClick={() => goVisualizarArquivos(record)}>
              <Icon.PaperClipOutlined />
            </Button>
          )}
        </>
      ),
    },
    {
      title: "AÇÕES",
      dataIndex: "acoes",
      align: "center",
      fixed: "right",
      width: 75,
      onCell: (record) => {
        return {
          onClick: (event) => {
            event.stopPropagation();
          },
        };
      },
      render: (_, record) => <AcoesComponent record={record} items={pendencia ? itemsPendencia : guia ? itemsGuia : items} />,
    },
  ];

  const columnsFinanceiro: ColumnsType<any> = [
    {
      title: "CONTA FINANCEIRA",
      dataIndex: "denominacao",
    },
    {
      title: "VALOR",
      dataIndex: "valor",
      align: "right",
      render: (_, record) => currencyBRL(record.valor),
    },
  ];

  const columnsCusto: ColumnsType<any> = [
    {
      title: "CENTRO DE CUSTO",
      dataIndex: "denominacao",
    },
    {
      title: "VALOR",
      dataIndex: "valor",
      align: "right",
      render: (_, record) => currencyBRL(record.valor),
    },
  ];

  return (
    <Flex vertical>
      <Filtro abrir={openFiltros} funcao={onChangeMostrarFiltros} />
      {openFiltros && <FiltroComponent idEmpresa={idEmpresaAtual} origem={pagar || guia || pendencia ? "contaFinanceiraD" : "contaFinanceiraR"} />}
      <Form form={form} layout="vertical" onFinish={goCadastrar} style={openFiltros ? { marginTop: "0px" } : { marginTop: "14px" }}>
        <Row gutter={12} align="middle">
          <Col span={20}>
            <Flex gap={12}>
              {persistedState.user.empresa === null && (
                <Form.Item
                  name="idEmpresa"
                  label="Empresa"
                  rules={[
                    {
                      required: true,
                      message: "Campo obrigatório",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    optionFilterProp="labelSearch"
                    placeholder="Selecione uma empresa"
                    loading={empresaState.loading}
                    onChange={onChangeEmpresa}
                    style={{ width: 300 }}
                    options={empresaState.list.map((a: EmpresaModel) => ({
                      value: a.id,
                      key: a.apelido,
                      label: (
                        <Flex justify="flex-start" align="center" gap={8} style={{ padding: "1px 0px" }}>
                          <Flex style={{ lineHeight: "0px" }}>{a.urlLogotipoPequeno && <Image width={25} height={25} style={{ lineHeight: "0px" }} src={a.urlLogotipoPequeno} preview={false} />}</Flex>
                          {a.apelido}
                        </Flex>
                      ),
                      labelSearch: a.apelido,
                    }))}
                  />
                </Form.Item>
              )}
              <Form.Item name="filtroTipo" label="Filtrar por">
                <Select
                  showSearch
                  optionFilterProp="label"
                  placeholder="Selecione uma opção"
                  onChange={onChangeFiltroTipo}
                  style={{ width: 150 }}
                  options={[
                    { value: "EMISS", label: "Emissão" },
                    { value: "VENCI", label: "Vencimento" },
                    { value: "COMPE", label: "Competência" },
                    { value: "PAGAM", label: "Pagamento" },
                    { value: "SORTE", label: "Sorteio" },
                  ]}
                />
              </Form.Item>
              <Form.Item label="Data início" name="dataInicio">
                <DatePicker placeholder="" allowClear={false} onChange={onChangeDateInicio} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label="Data fim" name="dataFim">
                <DatePicker placeholder="" allowClear={false} onChange={onChangeDateFim} format="DD/MM/YYYY" style={{ width: 120 }} />
              </Form.Item>
              <Form.Item label=" ">
                <Tooltip title="Atualizar">
                  <Button icon={<Icon.RedoOutlined />} className="buttonPrimary" style={{ minHeight: 32 }} onClick={atualizar} />
                </Tooltip>
              </Form.Item>
            </Flex>
          </Col>
          <Col span={4}>
            <Flex justify="end" gap={12}>
              {!pendencia && contaFinanceiraState.selectedRowKeys.keys.length !== 0 && !abrirDetalhes && (
                <Form.Item name="botaoPagar" label=" ">
                  <Tooltip title={pagar || guia ? "Pagar" : "Receber"}>
                    <Button className="pagarButton" type="primary" onClick={goPagar} icon={<Icon.DollarCircleOutlined />} />
                  </Tooltip>
                </Form.Item>
              )}
              <Form.Item name="botaoDetalhes" label=" ">
                <Tooltip title={abrirDetalhes ? "Esconder painel" : "Exibir painel"}>
                  <Button icon={abrirDetalhes ? <Icon.RightOutlined /> : <Icon.LeftOutlined />} onClick={clicouDetalhes} />
                </Tooltip>
              </Form.Item>
              {!pendencia && <ButtonComponent htmlType="submit" />}
            </Flex>
          </Col>
        </Row>
        <Row gutter={12} align="bottom">
          <Col span={24}>
            <Flex gap={12}>
              {pagar && (
                <Form.Item label="Contas:">
                  <Radio.Group style={{ width: "100%" }} options={radioOptionsParcelado} onChange={onChangeRadioParcelado} value={valueRadioParcelado} optionType="button" buttonStyle="solid" />
                </Form.Item>
              )}
              {guia && (
                <Form.Item label="Situação da guia">
                  <Select
                    onChange={onChangeStatusGuia}
                    style={{ width: 200 }}
                    options={[
                      { value: null, label: "Todas" },
                      { value: "NE", label: "Não enviada" },
                      { value: "AP", label: "Aguardando Pagamento" },
                      { value: "PG", label: "Paga" },
                    ]}
                  />
                </Form.Item>
              )}
              {pendencia && (
                <Form.Item label="Contas a:">
                  <Radio.Group style={{ width: "100%" }} options={radioOptions} onChange={onChangeRadioDespesaReceita} value={valueRadioDespesaReceita} optionType="button" buttonStyle="solid" />
                </Form.Item>
              )}
              {pendencia && (
                <Form.Item label="Exibir:">
                  <Radio.Group style={{ width: "100%" }} options={radioOptionsPendente} onChange={onChangeRadioPendente} value={valueRadioPendente} optionType="button" buttonStyle="solid" />
                </Form.Item>
              )}
            </Flex>
          </Col>
        </Row>
      </Form>
      <Flex gap={12} className="tabelacontaFinanceira">
        <TableComponent
          data={contaFinanceiraState.list}
          columns={abrirDetalhes ? columns.slice(0, 8).concat(columns.splice(10)) : columns}
          loading={contaFinanceiraState.loading}
          selectionType={selectionType}
          rowSelection={selecionarLinha}
          tableProps={{
            footer: () => (
              <Flex justify="flex-start" gap={10}>
                Legenda:
                <div className="circlePV">PV</div>
                Prevista
                <div className="circlePR">PR</div>
                Programada
                <div className="circleQT">QT</div>
                Quitada
                <div className="circleCC">CC</div>
                Cancelada
              </Flex>
            ),
            style: !abrirDetalhes ? { width: "100%" } : { width: "75%" },
            onRow: (record: ContaFinanceiraModel) => {
              return {
                onClick: () => {
                  goVisualizarResumo(record);
                },
              };
            },
            getCheckboxProps: (record: any) => ({
              disabled: (record.situacaoConta === "Cancelada" || record.situacaoConta === "Paga") && selectionType === "checkbox",
            }),
            selectedRowKeys: contaFinanceiraState.selectedRowKeys.keys,
          }}
        />
        {abrirDetalhes && (
          <Flex className="tabelasDetalhe" vertical>
            <Flex justify="space-between" align="center" className="headerDetalhe">
              <div>DETALHES DA CONTA</div>
              {verificarPermissaoEmpresa() && (
                <Flex align="center" gap={10}>
                  <Tooltip title="Anexos">
                    <Button onClick={goAnexarArquivo} icon={<Icon.PaperClipOutlined />}></Button>
                  </Tooltip>
                  {!pendencia && (
                    <Tooltip title="Editar rateio">
                      <Button onClick={() => goRateio()}>
                        <PhosphorIcon.Swap size="20px" />
                      </Button>
                    </Tooltip>
                  )}
                </Flex>
              )}
            </Flex>
            <div className="tabelasDentro">
              <TableComponent
                data={contaFinanceiraState.listRateio.filter((a: RateioModel) => a.grupo === "PlanoContaFinanceiro")}
                columns={columnsFinanceiro}
                loading={contaFinanceiraState.loadingRateio}
                pagination={false}
                tableProps={{
                  bordered: true,
                  style: { width: "100%" },
                }}
              />
              <Divider />
              <TableComponent
                data={contaFinanceiraState.listRateio.filter((a: RateioModel) => a.grupo === "CentroCusto")}
                columns={columnsCusto}
                loading={contaFinanceiraState.loadingRateio}
                pagination={false}
                tableProps={{
                  bordered: true,
                  style: { width: "100%" },
                }}
              />
            </div>
          </Flex>
        )}
      </Flex>
      <Modal title={"ANEXOS"} centered width={1100} open={arquivoAnexoState.modalArquivo} onCancel={closeModalArquivo} footer={null} destroyOnHidden>
        <UploadArquivosComponent
          visualizar={pendencia ? true : false}
          idOrigem={contaFinanceiraState.selectedRowKeys.keys[0] || contaFinanceiraState.entity.id}
          container={"contafinanceira"}
          origem="contaFinanceira"
        />
      </Modal>
      <Modal title={"DETALHES DA CONTA"} centered width={1100} open={contaFinanceiraState.modalRateio} onCancel={closeModalRateio} footer={null} destroyOnHidden>
        <Rateio
          conta={{
            id: contaFinanceiraState.selectedRowKeys.keys[0],
            valor: valor,
          }}
        />
      </Modal>
      <Modal title={"HISTÓRICO DA CONTA"} centered width={1100} open={contaFinanceiraState.modalHistorico} onCancel={closeModalHistorico} footer={null} destroyOnHidden>
        <HistoricoContaFinanceira />
      </Modal>
      <Modal
        title={pagar || guia ? "REMOVER CONTA A PAGAR" : "REMOVER CONTA A RECEBER"}
        centered
        width={350}
        open={contaFinanceiraState.modalDeletar}
        onCancel={closeModalDeletar}
        footer={null}
        destroyOnHidden
      >
        <MensagemModal
          text="Deseja remover esta conta a pagar?"
          action={deletarContaFinanceira({ value: contaFinanceiraState.entity.id, busca: contaFinanceiraState.busca })}
          close={setModalDeletarContaFinanceira(false)}
        />
      </Modal>
      <Drawer width={260} title="VISUALIZAR ANEXOS" placement="right" onClose={closeVisualizarArquivos} open={openVisualizarArquivos} getContainer={false}>
        <VisualizarArquivos />
      </Drawer>
      <Drawer width={500} title="VISUALIZAR RESUMO" placement="right" onClose={closeVisualizarResumo} open={openVisualizarResumo} getContainer={false}>
        <ResumoContaFinanceira contaFinanceira={contaFinanceiraState.entity} />
      </Drawer>
    </Flex>
  );
};

export default GeralPage;
